import * as Sentry from '@sentry/vue'
import { browserTracingIntegration } from '@sentry/vue'
import type { Plugin } from 'vue'

const sentryVuePlugin: Plugin = {
	install: (app) => {
		if (
			import.meta.env.PROD
				&& import.meta.env.VITE_SENTRY_DSN_PUBLIC
				&& import.meta.env.VITE_SENTRY_DSN_PUBLIC !== 'null'
		) {
			Sentry.init({
				app,
				dsn: import.meta.env.VITE_SENTRY_DSN_PUBLIC,
				integrations: [browserTracingIntegration()],
			})
		}
	},
}

export default sentryVuePlugin
